export default __webpack_public_path__ + "static/media/Frame_196.7a80eb71.jpg";